import { Breakpoints, styled } from '@vw-marketing/us-components';

export const ModalDisplayContainer = styled.div`
  position: fixed;
  z-index: 999;

  .internal-modal-layer-wrapper {
    @media (min-width: ${Breakpoints.b960 + 1}px) and (max-width: ${Breakpoints.b2560}px) {
      padding-top: 110px;
    }
  }

  .close-wrapper {
    top: 110px;

    @media (min-width: ${Breakpoints.b960 + 1}px) and (max-width: ${Breakpoints.b2560}px) {
      right: 21px;
    }

    @media (max-width: ${Breakpoints.b960}px) {
      right: 5px;
      top: 115px;
    }

    @media (max-width: ${Breakpoints.b560}px) {
      right: 10px;
      top: 80px;
    }
`;
